import { render, staticRenderFns } from "./OpenPatent.vue?vue&type=template&id=9f3c07aa&scoped=true"
import script from "./OpenPatent.vue?vue&type=script&lang=js"
export * from "./OpenPatent.vue?vue&type=script&lang=js"
import style0 from "./OpenPatent.vue?vue&type=style&index=0&id=9f3c07aa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3c07aa",
  null
  
)

export default component.exports